import { useState, useEffect, useRef } from 'react';

function readDark() {
  return document.documentElement.classList.contains('dark');
}

export default function useIsDark() {
  const [isDark, setIsDark] = useState(readDark);
  const isDarkRef = useRef(isDark);

  useEffect(() => {
    const handler = (e) => {
      const dark = e.detail.isDark;
      isDarkRef.current = dark;
      setIsDark(dark);
    };
    document.documentElement.addEventListener('themechange', handler);
    return () => document.documentElement.removeEventListener('themechange', handler);
  }, []);

  return { isDark, isDarkRef };
}
